import { render, staticRenderFns } from "./ShipOverviewPanel.vue?vue&type=template&id=4ab773d8&"
import script from "./ShipOverviewPanel.vue?vue&type=script&lang=js&"
export * from "./ShipOverviewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports